/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolFitnessCenterIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-fitness-center"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M6.95 8.8L4.17 11.57Q3.83 11.93 3.35 11.93Q2.88 11.93 2.52 11.57Q2.17 11.22 2.17 10.75Q2.17 10.28 2.52 9.93L3.2 9.25L2.48 8.53Q2.08 8.13 2.08 7.6Q2.08 7.08 2.48 6.67L3.65 5.5L2.92 4.78Q2.55 4.4 2.55 3.85Q2.55 3.3 2.92 2.92Q3.3 2.55 3.85 2.55Q4.4 2.55 4.78 2.92L5.5 3.65L6.67 2.48Q7.08 2.08 7.6 2.08Q8.13 2.08 8.53 2.48L9.25 3.2L9.93 2.52Q10.28 2.17 10.75 2.17Q11.22 2.17 11.57 2.52Q11.93 2.88 11.93 3.35Q11.93 3.83 11.57 4.17L8.8 6.95L17.05 15.2L19.82 12.43Q20.18 12.07 20.65 12.07Q21.13 12.07 21.48 12.43Q21.82 12.78 21.82 13.25Q21.82 13.72 21.48 14.07L20.8 14.75L21.52 15.47Q21.93 15.88 21.93 16.4Q21.93 16.93 21.52 17.32L20.35 18.5L21.07 19.23Q21.45 19.6 21.45 20.15Q21.45 20.7 21.07 21.07Q20.7 21.45 20.15 21.45Q19.6 21.45 19.23 21.07L18.5 20.35L17.32 21.52Q16.93 21.93 16.4 21.93Q15.88 21.93 15.47 21.52L14.75 20.8L14.07 21.48Q13.72 21.82 13.25 21.82Q12.78 21.82 12.43 21.48Q12.07 21.13 12.07 20.65Q12.07 20.18 12.43 19.82L15.2 17.05Z" fill={color} />
    </svg>
  );
}
